import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from '@fenderdigital/ui/Button';
import Spacer from '@fenderdigital/ui/Spacer';
import messages from './messages';
import NextVideoImage from './NextVideoImage';

const OnPathEndCard = ({ dataId, nextVideoPoster, nextVideoTitle, nextVideoType, onContinue }) => {
  const isPracticeSheet = nextVideoType === 'practice-sheet';
  let buttonMessage = messages.continue;

  if (isPracticeSheet) {
    buttonMessage = messages.start;
    nextVideoPoster = [
      'https://stuff.fendergarage.com/images/1/T/M/practice-mode-keyart-square.png',
      'https://stuff.fendergarage.com/images/1/T/M/practice-mode-keyart-square@2x.png',
    ];
  }

  function renderTitle() {
    if (isPracticeSheet) {
      return <FormattedMessage {...messages.nextPracticeSheet} />;
    }
    return <FormattedMessage {...messages.nextVideo} values={{ type: nextVideoType }} />;
  }

  function renderName() {
    if (isPracticeSheet) {
      return (
        <FormattedMessage {...messages.practiceSheetMessage} values={{ type: nextVideoTitle }} />
      );
    }
    return nextVideoTitle;
  }

  return (
    <div
      className="on-path-end-card flex items-center justify-center content-center"
      data-id={`${dataId}-next-poster`}
    >
      <NextVideoImage poster={nextVideoPoster} />
      <span className="white pl3 ma0 futura-book">
        <p className="ma0 ttu f6">{renderTitle()}</p>
        <p className="mb0 futura-heavy mt2 f6 f5-ns">{renderName()}</p>
        <Spacer />
        <Button colorScheme="blue" dataId={`${dataId}-continue`} onClick={onContinue}>
          <FormattedMessage {...buttonMessage} />
        </Button>
      </span>
    </div>
  );
};

OnPathEndCard.propTypes = {
  dataId: PropTypes.string,
  nextVideoPoster: PropTypes.string,
  nextVideoTitle: PropTypes.string,
  nextVideoType: PropTypes.string,
  onContinue: PropTypes.func,
};

OnPathEndCard.defaultProps = {
  dataId: '',
  nextVideoPoster: '',
  nextVideoTitle: '',
  nextVideoType: 'Lesson',
  onContinue: () => {},
};

export default OnPathEndCard;
